const PRIORITY_MAP = {
  high: 3,
  medium: 2,
  low: 1,
};

export default function sortActionItemsByCompletedThenPriority(actionItems) {
  return actionItems.sort((a, b) => {
    if (a.attr('status') !== 'completed' && b.attr('status') === 'completed') {
      return -1;
    }
    if (b.attr('status') !== 'completed' && a.attr('status') === 'completed') {
      return 1;
    }
    return PRIORITY_MAP[b.attr('priority')] - PRIORITY_MAP[a.attr('priority')];
  });
}
